import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/apiClient";
import { Loader2, Search, ChevronRight, Zap } from "lucide-react";

const FILTERS = [["all", "Tous"], ["active", "Actifs"], ["inactive", "Inactifs"]];

export default function ManagerArtists() {
  const { identity } = useAuth();
  const navigate = useNavigate();
  const [artists, setArtists] = useState(null);
  const [status, setStatus] = useState("all");
  const [search, setSearch] = useState("");

  useEffect(() => { if (identity && !identity.roles?.includes("MANAGER")) navigate("/become-manager"); }, [identity, navigate]);

  const load = useCallback(() => {
    api.get(`/manager/artists?status=${status}&search=${encodeURIComponent(search)}`)
      .then((r) => setArtists(r.data.artists)).catch(() => setArtists([]));
  }, [status, search]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  return (
    <div className="space-y-5" data-testid="manager-artists">
      <div>
        <h1 className="font-display text-3xl font-extrabold">Mes membres</h1>
        <p className="text-zinc-500 text-sm mt-1">Les membres qui t'ont autorisé à les accompagner.</p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Search className="w-4 h-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Rechercher un membre…" data-testid="artists-search"
            className="w-full h-11 pl-10 pr-4 rounded-xl bg-[#0F0F13] border border-zinc-800 text-sm text-zinc-200 focus:border-amber-500/50 outline-none" />
        </div>
        <div className="flex gap-2">
          {FILTERS.map(([k, l]) => (
            <button key={k} onClick={() => setStatus(k)} data-testid={`artists-filter-${k}`}
              className={`px-3 h-11 rounded-xl text-sm font-medium border ${status === k ? "bg-amber-500/15 text-amber-400 border-amber-500/40" : "border-zinc-800 text-zinc-400"}`}>{l}</button>
          ))}
        </div>
      </div>

      {artists === null ? (
        <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 text-amber-500 animate-spin" /></div>
      ) : artists.length === 0 ? (
        <div className="text-center py-14 text-zinc-600 text-sm" data-testid="artists-empty">Aucun membre ne correspond.</div>
      ) : (
        <div className="space-y-2">
          {artists.map((a) => (
            <button key={a.id} onClick={() => navigate(`/manager/artists/${a.id}`)} data-testid={`artist-row-${a.id}`}
              className="w-full flex items-center gap-3 bg-[#18181E] border border-zinc-800 rounded-2xl p-3 hover:border-amber-500/40 transition-colors text-left">
              <div className="w-11 h-11 rounded-xl overflow-hidden bg-zinc-900 flex items-center justify-center shrink-0">
                {a.avatar_url ? <img src={a.avatar_url} alt="" className="w-full h-full object-cover" /> : <span className="font-display font-bold text-amber-400">{(a.artist_name || a.name || "A")[0].toUpperCase()}</span>}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-zinc-100 truncate">{a.artist_name || a.name}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded-full border ${a.status === "ACTIVE" ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" : "bg-zinc-800 text-zinc-500 border-zinc-700"}`}>{a.status === "ACTIVE" ? "Actif" : "Inactif"}</span>
                </div>
                <div className="flex items-center gap-3 text-xs text-zinc-500 mt-0.5">
                  <span>Niv. {a.level}</span>
                  <span className="flex items-center gap-1"><Zap className="w-3 h-3 text-amber-400" />{a.xp}</span>
                  <span>Score {a.score}</span>
                  <span>{a.projects} projet(s)</span>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-zinc-600 shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
